import React, { useState, useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Link, useLocation } from 'react-router-dom';
import { updateGroup, createGroup } from "../api-mensagem";
import { ToastContainer, toast } from 'react-toastify';
import TextField from '@mui/material/TextField';

const useStyles = makeStyles({
    container: {
        paddingTop: '20px',
        paddingBottom: '20px',
    },
    title: {
        margin: '20px'
    },
});

export default function GroupForm() {
    const classes = useStyles();
    const [sala, setSala] = useState();
    const [isSaving, setIsSaving] = useState(false);
    const location = useLocation();

    useEffect(() => {

        if (location.state && location.state.sala) {
            setSala(location.state.sala);
        }

    }, [location.state]);

    const handleChange = (event) => {
        setSala({
            ...sala,
            descricao: event.target.value
        });
    }

    const clickSubmit = (event) => {
        event.preventDefault();
        setIsSaving(true);
        if (sala.codigo) {
            updateGroup(sala).then((data) => {
                if (data) {
                    setSala(data);
                    toast.success("Nome do Grupo Atualizado.", {
                        position: "bottom-left"
                    });
                }
            })
        } else {
            createGroup(sala).then((data) => {
                if (data) {
                    setSala(data);
                    toast.success("Grupo Criado com Sucesso.", {
                        position: "bottom-left"
                    });
                }
            })
        }
        setIsSaving(false);
    }


    return (
        <div>
            <CssBaseline />
            <ToastContainer autoClose={3000} />
            <Container className={classes.container} component={Paper}>
                <Button
                    component={Link}
                    to={{
                        pathname: '/mensagem'
                    }}
                    variant="contained"
                    color="secondary"
                    className={classes.voltarButton}
                >
                    <ArrowBackIcon style={{ marginRight: '10px' }} />
                    Voltar
                </Button>
                <Grid container justify="space-between">
                    <Typography className={classes.title} variant="h5">
                        Grupo
                    </Typography>
                </Grid>
                <form
                    onSubmit={clickSubmit}
                >
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        label="Nome do Grupo"
                        autoFocus
                        onChange={handleChange}
                        value={sala && sala.descricao ? sala.descricao : ''}
                        slotProps={{
                            htmlInput: { maxLength: 30 }
                        }}
                    />
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        disabled={isSaving}
                    >
                        Salvar
                    </Button>
                </form>

            </Container>
        </div>
    );
}